var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[(!_vm.loaded)?_c('h1',[_vm._v(_vm._s(_vm.$t("termsOfServiceView.title")))]):_vm._e(),_vm._v(" "),_c('ai-html-view',{attrs:{"url":"/Documents/terms-of-service.html"},on:{"load":function($event){_vm.loaded = true}}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }